import styled from '@emotion/styled'
import CONST from '../utils/const'

const THUMB_TYPES = CONST.TYPES

const THUMB_SIZE = {
  SMALL: 'SMALL',
  MEDIUM: 'MEDIUM'
}

const ThumbContainer = styled('div')`
  ${({
    hasWon,
    thumbSize,
    thumbType,
    theme: {
      colors: {
        components: { thumb }
      }
    }
  }) => {
    return `
      width: 160px;
      height: 160px;
      @media (max-width: 1366px) {
        width: 100px;
        height: 100px;
      }
      background: ${thumb.background};
      border-radius: 50%;
      display: table;
      cursor: ${hasWon === undefined ? 'pointer' : 'default'};
      transition: all 0.2s ease-in-out;
      user-select: none;
      transform: scale(${thumbSize === THUMB_SIZE.SMALL ? 1 : 1.4});
      box-shadow: ${
        hasWon
          ? '0 0 0 40px rgb(240 240 240 / 4%), 0 0 0 80px rgb(255 255 255 / 3%), 0 0 0 120px rgb(255 255 255 / 2%)'
          : 'none'
      };
      background: url(./images/${thumbType}.svg) no-repeat center;
      background-color: white;
      background-size: auto 80px;
      @media (max-width: 1366px) {
        background-size: auto 45px;
      }

      &::after {
        content: ' ';
        width: 130px;
        height: 130px;
        @media (max-width: 1366px) {
          width: 80px;
          height: 80px;
        }
        background-color: transparent;
        border-radius: 50%;
        border: 15px solid ${thumb[thumbType]};
        @media (max-width: 1366px) {
          border: 10px solid ${thumb[thumbType]};
        }
        box-shadow: inset 0px 4px 0px 1px ${thumb.shadow};
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      &:hover {
        transform: scale(${
          hasWon !== undefined ? 'none' : thumbSize === THUMB_SIZE.SMALL ? 1.05 : 1.45
        });
      }
    `
  }}
`

const Thumb = ({ thumbType, thumbSize, hasWon, ...props }) => {
  if (!thumbType) return null
  return <ThumbContainer thumbType={thumbType} thumbSize={thumbSize} hasWon={hasWon} {...props} />
}

export default Thumb
export { THUMB_TYPES, THUMB_SIZE }
